import React, { useContext } from 'react';
import { HeaderText } from '../../../../components';
import moment from 'moment';
import { Cancel, Groups } from '@mui/icons-material';
import { ThemeContext } from '../../../../context/theme/ThemeContext';

function Index(props) {
    const { meeting, setModal } = props;
    const { theme, changeTheme } = useContext(ThemeContext);
    return (
        <div className="row w-100 ">
            <div className="col-md-12 grid-margin stretch-card">
                <div className="">
                <h1><b>EVENT/CALENDAR</b></h1>
                    <div className="card-body"><div className="chartjs-size-monitor"><div className="chartjs-size-monitor-expand"><div className /></div><div className="chartjs-size-monitor-shrink"><div className /></div></div>
                        <HeaderText text={meeting?.name} />
                        {meeting?.course && (
                            <HeaderText text={"Course: " + meeting?.course?.title} />
                        )}
                        {!meeting?.course && (
                            <HeaderText text={meeting?.title} />
                        )}
                        <div className="regional-chart-legend d-flex align-items-center flex-wrap mb-1" id="regional-chart-legend">
                            <div className="item me-4 d-flex align-items-center">
                                <div className="item-box me-2" style={{ backgroundColor: '#1cbccd' }} />
                                <p className={theme === "light" ? "text-black mb-0" : "text-white mb-0"}> <b>Start Date:</b> {moment(meeting?.start_date).format("LL")} </p>
                            </div>
                            <div className="item d-flex align-items-center">
                                <div className="item-box me-2" style={{ backgroundColor: '#ffbf36' }} />
                                <p className={theme === "light" ? "text-black mb-0" : "text-white mb-0"}> <b>Start Time:</b>: {meeting?.start_time} </p>
                            </div>
                        </div>
                        <div className="regional-chart-legend d-flex align-items-center flex-wrap mb-1" id="regional-chart-legend">
                            <div className="item me-4 d-flex align-items-center">
                                <div className="item-box me-2" style={{ backgroundColor: '#1cbccd' }} />
                                <p className={theme === "light" ? "text-black mb-0" : "text-white mb-0"}> <b>End Date:</b> {moment(meeting?.end_date).format("LL")} </p>
                            </div>
                            <div className="item d-flex align-items-center">
                                <div className="item-box me-2" style={{ backgroundColor: '#ffbf36' }} />
                                <p className={theme === "light" ? "text-black mb-0" : "text-white mb-0"}> <b>End Time:</b>: {meeting?.end_time} </p>
                            </div>
                        </div>
                        <p className={theme === "light" ? "text-black mb-0" : "text-white mb-1"}>
                            {meeting?.description}
                        </p>
                        <div className={theme === "light" ? "text-black mb-0" : "text-white mb-0"} dangerouslySetInnerHTML={{ __html: meeting?.content }}>

                        </div>
                        <div class="d-flex flex-row mt-4">
                            <button onClick={() => setModal(false)} type="button" class="d-flex flex-row items-center justify-center btn btn-outline-secondary " >
                                <Cancel sx={{ marginRight: 2 }} fontSize="small" />
                                Close
                            </button>
                            {meeting?.meeting_link && (
                                <a href={meeting?.meeting_link}
                                    target="_blank" type="button" class="d-flex flex-row items-center justify-center btn btn-outline-secondary mx-2" >
                                    <Groups sx={{ marginRight: 2 }} fontSize="small" />
                                    Open Link
                                </a>)}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Index;